import { graphql, useStaticQuery } from "gatsby"
import * as React from "react"
import {
  Facebook, GitHub, Instagram, Linkedin, Twitch, Twitter, Youtube
} from "react-feather"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSpotify } from "@fortawesome/free-brands-svg-icons";
import BrandLogo from "./brand-logo.js"
import {
  Base,
  Box, Container, Flex,
  FlexList, IconLink, NavLink, Space, Text, VisuallyHidden
} from "./ui"
import * as styles from "./ui.css";

const Spotify = ({ style }) => {
  return (
    <Base cx={[styles.faIcon]}>
      <FontAwesomeIcon icon={faSpotify} style={style} />
    </Base>
  );
}

const socialMedia = {
  TWITTER: {
    url: "https://twitter.com",
    name: "Twitter",
    icon: Twitter,
  },
  INSTAGRAM: {
    url: "https://instagram.com",
    name: "Instagram",
    icon: Instagram,
  },
  FACEBOOK: {
    url: "https://facebook.com",
    name: "Facebook",
    icon: Facebook,
  },
  YOUTUBE: {
    url: "https://youtube.com",
    name: "YouTube",
    icon: Youtube,
  },
  GITHUB: {
    url: "https://github.com",
    name: "GitHub",
    icon: GitHub,
  },
  LINKEDIN: {
    url: "https://br.linkedin.com/company",
    name: "Linkedin",
    icon: Linkedin,
  },
  TWITCH: {
    url: "https://twitch.tv",
    name: "Twitch",
    icon: Twitch,
  },
  SPOTIFY: {
    url: "https://open.spotify.com/show",
    name: "Spotify",
    icon: Spotify,
  }
}

const getSocialURL = ({ service, username }) => {
  const domain = socialMedia[service]?.url
  if (!domain) return false
  return `${domain}/${username}`
}

const getSocialIcon = ({ service }) => {
  const IconComponent = socialMedia[service]?.icon
  const result = <IconComponent style={{ color: 'white', width: 16, height: 16, margin: 0 }} />
  return result;
}

const getSocialName = ({ service }) => {
  return socialMedia[service]?.name
}

export default function Footer() {
  const data = useStaticQuery(graphql`
    query {
      layout {
        footer {
          id
          links {
            id
            name
            navItems {
              id
              text
              href
            }
          }
          meta {
            id
            href
            text
          }
          copyright
          address
          cnpj
          footerSlogan
          socialLinks {
            id
            service
            username
          }
        }
      }
    }
  `)

  const { links, meta, socialLinks, copyright, address, cnpj, footerSlogan } = data.layout.footer
  return (
    <Box as="footer" style={{ backgroundColor: '#00A385', paddingTop: 48, paddingBottom: 50 }}>
      <Container cx={[styles.footerContainer]}>
        <Flex variant="start" responsive cx={[styles.footerTop]} gap={0}>
          <Base as="div">
            <VisuallyHidden>Home</VisuallyHidden>
            <BrandLogo height={50} color="#ffffff" />
            <Base as="div" cx={[styles.footerTextLeft]}>
              <Text>
                {address.split('<br>').map((item) => {
                  return (
                    <>
                      {item}
                      <br />
                    </>
                  )
                })}
                CNPJ: {cnpj}
              </Text>
            </Base>
            <FlexList style={{ gap: 0, paddingTop: 10 }}>
              {socialLinks &&
                socialLinks.map((link) => {
                  console.log(link);
                  const url = getSocialURL(link)
                  return (
                    url && (
                      <Base as='li' key={link.id} cx={[styles.socialLinkMobile]}>
                        <IconLink to={url} style={{ marginRight: 0 }} target="_blank">
                          <VisuallyHidden>{getSocialName(link)}</VisuallyHidden>
                          {getSocialIcon(link)}
                        </IconLink>
                      </Base>
                    )
                  )
                })}
            </FlexList>
          </Base>
          <Flex variant="start" responsive gap={0} cx={[styles.otherLinks]}>
            {links &&
              links.map((link, i) => {
                return (
                  <Base as="div" cx={[styles.footerLinksLi]} key={link.id}>
                    <Text cx={[styles.footerLinksTitle]}>{link.name}</Text>
                    {
                      link.navItems.map((item) => {
                        return <NavLink to={item.href} target="_blank" cx={[styles.navLinkItem]}>
                          <Text variant="footerlinksmall">{item.text}</Text>
                        </NavLink>
                      })
                    }
                  </Base>
                )
              })}
          </Flex>
        </Flex>
        <Flex variant="start" responsive cx={[styles.footerBottom]} gap={0}>
          <Space />
          <FlexList style={{ gap: 0, paddingTop: 10 }}>
            {meta &&
              meta.map((link, i) => (
                <li key={link.id} style={{ marginRight: (i == meta.length - 1) ? 0 : 28, marginTop: 0 }}>
                  <NavLink to={link.href} target="_blank">
                    <Text variant="footerlinksmall">{link.text}</Text>
                  </NavLink>
                </li>
              ))}
          </FlexList>
          <Space />
          <Text variant="copyrightsmall">
            {copyright}
          </Text>
          <Space />
        </Flex>
      </Container>
    </Box >
  )
}
